import { Box, Button, Grid, styled } from '@mui/material';

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 16px 24px;
  width: 1280px;
  height: 820px;
`;

export const FluidWidthColumn = styled(Grid)`
  height: 60vh;
  overflow-y: scroll;
`;

export const AlertContainer = styled(Box)`
  padding-bottom: 20px;
`;

export const HeaderWrapper = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CreateAssemblyButton = styled(Button)(
  ({ theme, disabled }) => `
  min-width: 126px;
  border: 1px solid;
  color: ${theme.palette.primary.main};
  background-color: white;

  & path {
    fill: ${
      disabled ? theme.palette.brand.disable : theme.palette.primary.main
    };
  }
`,
);
